import { trimEnd } from 'lodash';
import URI from 'urijs';

export default (path, sectionUrl) => {
  const url = new URI(sectionUrl || '');
  url.pathname(trimEnd(url.pathname(), '/') + path);
  return url.toString();
};
